import React, { useEffect, useState } from 'react';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import {
    Grid,
    IconButton,
    Button,
    InputAdornment,
    MenuItem,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import { sendSucces } from '../../../utils/utils';
import {
    deletePartyCharge,
    deletePartyDeduction
} from "../../../store/actions/tripActionCreator";

const useStyles = makeStyles(() => ({

    dialogContentV1: {
        paddingLeft: 20,
        paddingRight: 20,
        paddingTop: 12,
        paddingBottom: 18
    },
    dialogActionsV1: {
        paddingTop: 0,
        paddingLeft: 20,
        paddingRight: 20,
        paddingBottom: 16,
        display: 'flex',
        justifyContent: 'flex-end'
    },
    buttonNo: {
        fontSize: '16px',
        color: 'rgba(11, 19, 35, 0.75)',
        textTransform: 'none',
        marginRight: 8
    },
    buttonYes: {
        fontSize: '16px',
        color: '#4d6bc8',
        textTransform: 'none'
    },
    paperWidthV1: {
        width: 330
    },
    brV1: {
        borderRadius: '8px !important'
    },
    dialogTitleV1: {
        paddingLeft: 20,
        paddingTop: 16,
        paddingRight: 8,
        paddingBottom: '0px !important'
    },
    divAlignTitle: {
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between'
    },
    titleText: {
        fontSize: 20,
        fontWeight: 600,
        color: '#ff0000'
    },
    closeIcon: {
        color: '#9ea0a5',
    },
    textV1: {
        fontSize: 16
    }

}));

const DeleteChargeDeductionDialog = ({ open, onClose, onConfirm, transactTypeValue, deleteId, tripIdValue, dispatchDeletePartyCharge, dispatchDeletePartyDeduction }) => {

    const [dialogOpen, setDialogOpen] = useState(open)

    const classes = useStyles();

    const handleClose = () => {
        setDialogOpen(false);
        onClose();
    }

    const handleDelete = () => {

        if (transactTypeValue == "Charge") {

            dispatchDeletePartyCharge(tripIdValue, deleteId,
                (response) => {
                    if (response && response.status && response.status && response.status.code && response.status.code === 200) {
                        sendSucces("Party Charge Deleted Suceessfully!");
                        setDialogOpen(false);
                        onConfirm();
                    }
                },
                () => {

                })

        } else if (transactTypeValue == "Deduction") {

            dispatchDeletePartyDeduction(tripIdValue, deleteId,
                (response) => {
                    if (response && response.status && response.status && response.status.code && response.status.code === 200) {
                        sendSucces("Party Deduction Deleted Suceessfully!");
                        setDialogOpen(false);
                        onConfirm();
                    }
                },
                () => {
                })

        }

    }

    return (
        <>
            <Dialog
                open={dialogOpen}
                onClose={handleClose}
                disableEscapeKeyDown={true}
                disableBackdropClick={true}
                classes={{ paperWidthXs: classes.paperWidthV1, paperScrollPaper: classes.brV1 }}
                maxWidth="xs"
            >

                <DialogTitle className={classes.dialogTitleV1}>
                    <div className={classes.divAlignTitle}>
                        <div className={classes.titleText}>Delete&nbsp;{transactTypeValue}</div>
                        <IconButton aria-label="close" onClick={handleClose}>
                            <CloseIcon className={classes.closeIcon} />
                        </IconButton>
                    </div>
                </DialogTitle>

                <DialogContent className={classes.dialogContentV1}>
                    <div className={classes.textV1}>
                        Are you Sure You want to Delete&nbsp;{transactTypeValue}&nbsp; ?
                    </div>
                </DialogContent>

                <DialogActions className={classes.dialogActionsV1}>
                    <Button className={classes.buttonNo} onClick={() => handleClose()}>
                        No
                    </Button>
                    <Button className={classes.buttonYes} onClick={() => handleDelete()}>
                        Yes
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    )
}

const mapStateToProps = (state) => (state);
const mapDispatchToProps = (dispatch) => ({

    dispatchDeletePartyCharge: (tripId, expenseId, onSuccess, onFailure) => {
        dispatch(deletePartyCharge(
            tripId,
            expenseId,
            null,
            onSuccess,
            onFailure
        ))
    },
    dispatchDeletePartyDeduction: (tripId, deductionId, onSuccess, onFailure) => {
        dispatch(deletePartyDeduction(
            tripId,
            deductionId,
            null,
            onSuccess,
            onFailure
        ))
    },

});
export default connect(mapStateToProps, mapDispatchToProps)(DeleteChargeDeductionDialog);